const fakeAuth = {
  signIn(cb: () => Promise<any>) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        cb()
          .then((cookie) => resolve(cookie))
          .catch(reject);
      }, 100);
    });
  },
  signInPhone(cb: () => Promise<any>) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        cb()
          .then((cookie) => resolve(cookie))
          .catch(reject);
      }, 100);
    });
  },
  signOut(cb: () => void) {
    setTimeout(cb, 100);
  },
};

export default fakeAuth;
